import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "./ThemeContext";
import { FaDiscord, FaPatreon, FaInstagram } from "react-icons/fa";

export default function Services() {
  const { darkMode, setDarkMode } = useTheme();

  return (
    <div className="min-h-screen bg-white text-black dark:bg-black dark:text-white transition-all duration-300">
      {/* NAVBAR */}
      <div className="flex justify-between items-center px-6 py-4 border-b border-gray-700">
        <h1 className="text-2xl font-bold text-red-500">ZXL Studio</h1>
        <div className="flex items-center space-x-6 text-sm text-gray-300">
          <nav className="space-x-4">
            <Link to="/" className="hover:underline text-red-400">Home</Link>
            <Link to="/contact" className="hover:underline text-red-400">Contact</Link>
            <a href="https://zxldev.com/blog" target="_blank" rel="noopener noreferrer" className="hover:underline text-red-400">Blog</a>
			<a href="https://zxldev.com/forums" target="_blank" rel="noopener noreferrer">Forums</a>
          </nav>
          <div className="flex items-center space-x-3 text-xl">
            <a href="https://discord.com/channels/1077475224032911370/1077475224502681665" target="_blank" rel="noopener noreferrer"><FaDiscord className="hover:text-white" /></a>
            <a href="https://www.instagram.com/zxlstudio/?igsh=aGswYndpcm81OXFx " target="_blank" rel="noopener noreferrer"><FaInstagram className="hover:text-white" /></a>
			<a href="https://www.patreon.com/zxlstudio" target="_blank" rel="noopener noreferrer"><FaPatreon className="hover:text-white" /></a>
          </div>
          <button
            onClick={() => setDarkMode(!darkMode)}
            className="p-2 text-xl bg-transparent hover:text-white transition-colors duration-200"
            title="Toggle theme"
          >
            {darkMode ? "☀" : "🌙"}
          </button>
        </div>
      </div>

      <main className="px-6 py-10 font-sans">
        <header className="mb-10 text-center">
          <h1 className="text-4xl font-bold mb-2">Services</h1>
          <p className="text-lg text-gray-400">What I can offer for your game or digital project</p>
        </header>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          <div className="bg-gray-900 p-6 rounded-2xl shadow-md">
            <h2 className="text-xl font-semibold mb-2">AI-Generated Character Art</h2>
            <p className="text-gray-300 text-sm">
              Designing high-quality artwork using AI, specializing in fantasy characters and creatures. Delivered as layered PSD or web-ready PNG.
            </p>
          </div>

          <div className="bg-gray-900 p-6 rounded-2xl shadow-md">
            <h2 className="text-xl font-semibold mb-2">AI-Generated Videos</h2>
            <p className="text-gray-300 text-sm">
              Designing high-quality short video clips using AI, specializing in characters shots and event scenes. Delivered as .webm, .mp4 or .mov.
            </p>
          </div>

          <div className="bg-gray-900 p-6 rounded-2xl shadow-md">
            <h2 className="text-xl font-semibold mb-2">Lore Writing & Dialogue</h2>
            <p className="text-gray-300 text-sm">
              Crafting immersive lore entries, character backstories, and quest dialogue tailored for medieval, fantasy, or erotic themes.
            </p>
          </div>

          <div className="bg-gray-900 p-6 rounded-2xl shadow-md">
            <h2 className="text-xl font-semibold mb-2">RPG Maker Event Scripting</h2>
            <p className="text-gray-300 text-sm">
              Creating event systems, scripted mechanics, and plugin-based features using JavaScript within RPG Maker MZ. Systems include QTEs, shops, combat triggers, and branching cutscenes.
            </p>
          </div>

          <div className="text-center mt-10 col-span-full">
            <Link to="/" className="inline-block bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-600">
              ← Return to Home
            </Link>
          </div>
        </section>

        <footer className="mt-16 text-center">
          <p className="text-gray-400">
            Contact me via {" "}
            <a href="mailto:bettibettilucci@gmail.com" className="text-blue-400 hover:underline">
              email
            </a>{" "}
            or through my {" "}
            <a href="https://www.patreon.com/zxlstudio" className="text-blue-400 hover:underline">
              Patreon
            </a>{" "}
            for commissions or collaborations.
          </p>
        </footer>
      </main>
    </div>
  );
}
